import React from 'react';

// Components
import { ConversationNotifications } from '../modules/conversation-notifications/conversation-notifications';

// Styles
import './chat-status-not-answered.scss';

export const ChatStatusNotAnswered = () => {

  const workerId = localStorage.getItem('worker_id');
  const returnPathname = localStorage.getItem('return_pathname') ?? `/expert/${workerId}`;

  return (<ConversationNotifications
    title={'No Answer'}
    text={'We apologize for the inconvenience. The Consultant could not respond to your connection, but rest assured that the payment for the Text Chat will be refunded to you.'}
    navigateAction={returnPathname}  />);
}
